/* Arawaka Coffee · interacciones del tema (sobre Dawn 16) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var AWT = window.AW_T || {};
  var L = function (k) { return AWT[k] != null ? String(AWT[k]) : ''; };
  var money = function (c) { var v = c / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); };

  /* ---------- Carrito (usa el cajón de Dawn) ---------- */
  function addItems(items, btn, errEl) {
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    if (errEl) errEl.hidden = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { throw new Error(res.description || res.message || L('add_error')); }
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.renderContents === 'function') {
        d.classList.remove('is-empty');
        d.renderContents(res);
      } else { location.href = '/cart'; }
      awCartRefresh(true);
    }).catch(function (e) {
      if (errEl) { errEl.textContent = e.message; errEl.hidden = false; } else { alert(e.message); }
    }).finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }
  window.awAdd = addItems;

  /* ---------- Encabezado, menú y película ---------- */
  function initHeader() {
    var hdr = $('#hdr');
    if (!hdr) return;
    var wrap = hdr.closest('.aw-header-wrap');
    if (wrap && wrap.classList.contains('is-overlay')) {
      var onS = function () { hdr.classList.toggle('solid', scrollY > 60); };
      addEventListener('scroll', onS, { passive: true }); onS();
    }
  }
  window.awMenu = function (o) {
    document.body.classList.toggle('aw-menu-open', o);
    var m = $('#mmenu'); if (m) m.setAttribute('aria-hidden', !o);
    var b = $('.burger'); if (b) b.setAttribute('aria-expanded', o ? 'true' : 'false');
  };

  /* ---------- Barra fija del carrito ---------- */
  function awCartRefresh(pulse) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var bar = $('#awcb'); var goal = bar ? +bar.dataset.goal : 6000;
      var left = Math.max(0, goal - c.total_price), pct = Math.min(100, Math.round(c.total_price / goal * 100));
      var shipHtml = left > 0 ? L('left').replace('__A__', money(left)) : L('unlocked');
      if (bar) {
        bar.querySelector('[data-cb-count]').textContent = c.item_count;
        bar.querySelector('[data-cb-total]').textContent = money(c.total_price);
        bar.querySelector('[data-cb-items]').textContent = L(c.item_count === 1 ? 'items_one' : 'items_other').replace('__N__', c.item_count);
        bar.querySelector('[data-cb-ship]').innerHTML = shipHtml;
        bar.querySelector('[data-cb-bar]').style.width = pct + '%';
        bar.querySelector('.aw-cb-in').style.setProperty('--aw-cbp', pct + '%');
        bar.classList.toggle('free', left <= 0);
        bar.classList.toggle('show', c.item_count > 0);
        if (pulse && c.item_count > 0) { bar.classList.remove('pulse'); void bar.offsetWidth; bar.classList.add('pulse'); }
      }
      document.body.classList.toggle('aw-cb-on', c.item_count > 0);
      $$('[data-aw-count]').forEach(function (e) { e.textContent = c.item_count; });
      var mt = $('[data-aw-mship-t]'), mb = $('[data-aw-mship-b]');
      if (mt) mt.innerHTML = c.item_count === 0 ? L('from').replace('__A__', money(goal).replace(/\.00$/, '')) : (left > 0 ? shipHtml : L('free'));
      if (mb) mb.style.width = pct + '%';
    }).catch(function () {});
  }
  window.awCartRefresh = awCartRefresh;
  function initCartBar() {
    var bar = $('#awcb'); if (!bar) return;
    document.body.classList.toggle('aw-cb-on', bar.classList.contains('show'));
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) { try { subscribe(PUB_SUB_EVENTS.cartUpdate, function () { awCartRefresh(false); }); } catch (e) {} }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) awCartRefresh(false); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) awCartRefresh(false); });
  }
  window.awFilm = function (o, id) {
    var ms = id ? [document.getElementById(id)] : (o ? [$('#awfilm')] : $$('.aw-modal.on'));
    ms.forEach(function (m) {
      if (!m) return;
      var v = m.querySelector('video');
      m.classList.toggle('on', o);
      if (v) { if (o) { try { v.currentTime = 0; } catch (e) {} v.play().catch(function () {}); } else v.pause(); }
    });
  };
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { window.awMenu(false); window.awFilm(false); } });

  /* ---------- Aparición, videos en pantalla, parallax ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12 }) : null;
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); });
  }, { threshold: 0.5 }) : null;
  function initReveal(root) {
    var design = window.Shopify && Shopify.designMode;
    $$('.aw .reveal', root).forEach(function (el) { if (design || !io) el.classList.add('in'); else io.observe(el); });
    $$('.aw .reel video, .aw .step video', root).forEach(function (v) { if (vio) vio.observe(v); });
  }
  function initParallax() {
    var px = $$('.aw [data-parallax], .aw.film > img');
    if (!px.length) return;
    addEventListener('scroll', function () {
      px.forEach(function (el) { var r = el.parentElement.getBoundingClientRect(); if (r.bottom > 0 && r.top < innerHeight) el.style.transform = 'scale(1.1) translateY(' + (r.top / innerHeight) * -40 + 'px)'; });
    }, { passive: true });
  }

  /* ---------- Carrusel de reseñas (coverflow) ---------- */
  function initReels(root) {
    $$('[data-aw-cf]', root).forEach(function (cfw) {
      var track = cfw.querySelector('.reels'); var cards = Array.prototype.slice.call(track.children); if (!cards.length) return;
      var ci = Math.min(2, cards.length - 1);
      function go(n) { ci = (n + cards.length) % cards.length; cards.forEach(function (c, k) { c.classList.toggle('on', k === ci); }); var c = cards[ci]; track.style.transform = 'translateX(' + (cfw.clientWidth / 2 - (c.offsetLeft + c.offsetWidth / 2)) + 'px)'; }
      cards.forEach(function (c, k) { var v = c.querySelector('.v'); if (v) v.addEventListener('click', function () { go(k); }); });
      var sec = cfw.closest('section');
      var p = sec.querySelector('[data-aw-cfprev]'), n = sec.querySelector('[data-aw-cfnext]');
      if (p) p.addEventListener('click', function () { go(ci - 1); });
      if (n) n.addEventListener('click', function () { go(ci + 1); });
      addEventListener('resize', function () { go(ci); });
      setTimeout(function () { go(ci); }, 50);
    });
  }

  /* ---------- Utilidades de grupo (molido/grano + tamaño) ---------- */
  function variantFor(group, grind, oz) {
    var p = group[grind]; if (!p) return null;
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].oz === +oz) return p.variants[i];
    return null;
  }
  function sizesFor(group, grind) {
    var p = group[grind]; if (!p) return [];
    return p.variants.map(function (v) { return v.oz; }).sort(function (a, b) { return a - b; });
  }
  function segOn(seg, val) { $$('button', seg).forEach(function (b) { b.classList.toggle('on', b.dataset.v === String(val)); }); }
  function segVal(seg) { var b = seg && seg.querySelector('button.on'); return b ? b.dataset.v : null; }
  function ppo(v) { return v && v.oz ? money(Math.round(v.price / v.oz)) + ' / oz' : ''; }

  /* ---------- Tarjetas de la tienda (inicio y colección) ---------- */
  function initShop(root) {
    $$('.aw-shop', root).forEach(function (sec) {
      var dataEl = sec.querySelector('[data-aw-groups]'); if (!dataEl) return;
      var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      $$('[data-aw-card]', sec).forEach(function (card) {
        var g = data[card.dataset.awCard]; if (!g || !g.ground) return;
        var gs = card.querySelector('[data-aw-grind]'), ss = card.querySelector('[data-aw-size]');
        if (!g.whole) { gs.closest('.opt').style.display = 'none'; }
        function sync() {
          var grind = segVal(gs) || 'ground';
          var sizes = sizesFor(g, grind);
          $$('button', ss).forEach(function (b) { var ok = sizes.indexOf(+b.dataset.v) > -1; b.disabled = !ok; b.classList.toggle('off', !ok); });
          if (sizes.indexOf(+segVal(ss)) < 0) segOn(ss, sizes[0]);
          var v = variantFor(g, grind, segVal(ss));
          card.querySelector('[data-price]').textContent = v ? money(v.price) : '—';
          var pp = card.querySelector('[data-ppo]'); if (pp) pp.textContent = v ? ppo(v) : '';
          var b = card.querySelector('[data-aw-add]');
          b.disabled = !v || !v.available; b.textContent = v && v.available ? L('add_to_cart') : L('sold_out');
          card._v = v;
          var a = card.querySelectorAll('a.pimg, h3 a, .aw-more'); var url = g[grind] && g[grind].url;
          if (url) Array.prototype.forEach.call(a, function (x) { x.href = url; });
        }
        [gs, ss].forEach(function (seg) { seg.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b || b.disabled) return; segOn(seg, b.dataset.v); sync(); }); });
        card.querySelector('[data-aw-add]').addEventListener('click', function (e) { if (card._v) addItems([{ id: card._v.id, quantity: 1 }], e.currentTarget); });
        sync();
      });
      $$('[data-aw-duo]', sec).forEach(function (b) {
        b.addEventListener('click', function () { var ids = b.dataset.awDuo.split(','); addItems(ids.map(function (id) { return { id: +id, quantity: 1 }; }), b); });
      });
      $$('[data-aw-quick]', sec).forEach(function (b) { b.addEventListener('click', function () { addItems([{ id: +b.dataset.awQuick, quantity: 1 }], b); }); });
      var prods = sec.querySelector('.products'), dots = $$('.swipe-hint b i', sec);
      if (prods && dots.length) prods.addEventListener('scroll', function () { var k = Math.round(prods.scrollLeft / (prods.scrollWidth - prods.clientWidth || 1)); dots.forEach(function (d, n) { d.classList.toggle('on', n === k); }); }, { passive: true });
      var mbar = sec.querySelector('#mbar');
      if (mbar) {
        addEventListener('scroll', function () { var f = document.querySelector('footer.aw-foot'); var fb = f ? f.getBoundingClientRect().top : 1e9; mbar.classList.toggle('show', scrollY > innerHeight * 0.85 && fb > innerHeight); }, { passive: true });
      }
    });
  }

  /* ---------- Constructor de suscripción ---------- */
  function initSub(root) {
    $$('[data-aw-sub]', root).forEach(function (box) {
      var src = box.querySelector('[data-aw-sgroups]') || document.querySelector('[data-aw-groups]'); if (!src) { box.style.display = 'none'; return; }
      var data; try { data = JSON.parse(src.textContent); } catch (e) { return; }
      var sc = box.querySelector('[data-aw-sc]'), sg = box.querySelector('[data-aw-sg]'), sf = box.querySelector('[data-aw-sf]'), sq = box.querySelector('[data-aw-sq]');
      var tot = box.querySelector('[data-aw-stotal]'), size = box.querySelector('[data-aw-ssize]'), btn = box.querySelector('[data-aw-sadd]');
      function pick() {
        var g = data[segVal(sc)]; var grind = segVal(sg) || 'ground'; if (!g || !g[grind]) grind = 'ground';
        var sizes = sizesFor(g, grind); var v = variantFor(g, grind, sizes.indexOf(8) > -1 ? 8 : sizes[0]);
        var plan = g[grind] && g[grind].plans ? g[grind].plans[segVal(sf)] : null;
        return { g: g, grind: grind, v: v, plan: plan };
      }
      function calc() {
        var s = pick(); var q = +segVal(sq) || 1; var d = +(sf.querySelector('.on').dataset.d);
        if (!s.v) { tot.textContent = '—'; return; }
        var full = s.v.price * q, t = Math.round(full * (1 - d / 100));
        tot.innerHTML = money(t) + '<s>' + money(full) + '</s><small>' + L('per_delivery') + '</small>';
        size.textContent = q + ' ' + (q > 1 ? L('bags') : L('bag')) + ' ' + L('of') + ' ' + s.v.oz + ' oz · ' + (s.grind === 'whole' ? L('whole_l') : L('ground_l'));
        btn.disabled = !s.plan || !s.v.available;
        btn.textContent = s.plan ? L('sub_start') : L('sub_na');
      }
      [sc, sg, sf, sq].forEach(function (seg) { seg.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; segOn(seg, b.dataset.v); calc(); }); });
      btn.addEventListener('click', function () { var s = pick(); if (!s.v || !s.plan) return; addItems([{ id: s.v.id, quantity: +segVal(sq) || 1, selling_plan: +s.plan }], btn); });
      calc();
    });
  }

  /* ---------- Ficha de producto ---------- */
  function initPDP(root) {
    $$('[data-aw-pdp]', root).forEach(function (sec) {
      var g; try { g = JSON.parse(sec.querySelector('[data-aw-pdata]').textContent); } catch (e) { return; }
      if (!g || !g.ground) return;
      var grind = sec.dataset.grind === 'whole' && g.whole ? 'whole' : 'ground';
      var gs = sec.querySelector('[data-aw-grind]'), ss = sec.querySelector('[data-aw-size]'), fs = sec.querySelector('[data-aw-freq]');
      var q = sec.querySelector('[data-aw-q]'), err = sec.querySelector('[data-aw-err]');
      if (!g.whole) sec.querySelector('[data-aw-grindwrap]').style.display = 'none';
      segOn(gs, grind);
      var params = new URLSearchParams(location.search); var want = params.get('variant');
      var oz = null;
      if (want) g[grind].variants.forEach(function (v) { if (String(v.id) === want) oz = v.oz; });
      function buildSizes() {
        var sizes = sizesFor(g, grind);
        ss.innerHTML = sizes.map(function (o) { return '<button type="button" data-v="' + o + '">' + o + ' oz</button>'; }).join('');
        if (sizes.indexOf(+oz) < 0) { var av = g[grind].variants.filter(function (v) { return v.available; }).sort(function (a, b) { return a.oz - b.oz; })[0]; oz = av ? av.oz : sizes[0]; }
        segOn(ss, oz);
      }
      function ptype() { var r = sec.querySelector('input[name="aw-pt"]:checked'); return r ? r.value : 'once'; }
      function sync() {
        var v = variantFor(g, grind, oz); sec._v = v;
        var plans = g[grind].plans || {}; var hasSub = !!(plans.w2 || plans.m);
        var so = sec.querySelector('[data-aw-subopt]'); so.style.display = hasSub ? '' : 'none';
        $$('button', fs).forEach(function (b) { b.style.display = plans[b.dataset.v] ? '' : 'none'; });
        if (!plans[segVal(fs)]) { var first = $$('button', fs).filter(function (b) { return plans[b.dataset.v]; })[0]; if (first) segOn(fs, first.dataset.v); }
        if (!hasSub && ptype() === 'sub') sec.querySelector('input[value="once"]').checked = true;
        var d = +((fs.querySelector('.on') || {}).dataset || {}).d || 0;
        var price = v ? v.price : 0, subp = Math.round(price * (1 - d / 100));
        var isSub = ptype() === 'sub';
        sec.querySelector('[data-price]').textContent = v ? money(isSub ? subp : price) : '—';
        var was = sec.querySelector('[data-was]'); was.hidden = !isSub; was.textContent = money(price);
        sec.querySelector('[data-ppo]').textContent = v ? '(' + money(Math.round((isSub ? subp : price) / v.oz)) + ' / oz)' : '';
        sec.querySelector('[data-aw-once]').textContent = v ? money(price) : '';
        sec.querySelector('[data-aw-subp]').textContent = v ? money(subp) + ' · ' + L('you_save') + ' ' + money(price - subp) : '';
        $$('.aw-pt', sec).forEach(function (l) { l.classList.toggle('on', l.querySelector('input').checked); });
        var ok = v && v.available;
        [sec.querySelector('[data-aw-padd]'), sec.querySelector('[data-aw-padd2]')].forEach(function (b) { if (!b) return; b.disabled = !ok; b.textContent = ok ? (b.hasAttribute('data-aw-padd2') ? L('add') : (isSub ? L('subscribe') : L('add_to_cart'))) : L('sold_out'); });
        var st = sec.querySelector('[data-aw-stxt]'); if (st && v) st.textContent = (grind === 'whole' ? L('whole') : L('ground')) + ' · ' + v.oz + ' oz · ' + money(isSub ? subp : price);
        if (g[grind].url && history.replaceState) { var u = g[grind].url + (v ? '?variant=' + v.id : ''); if (location.pathname !== g[grind].url || location.search !== (v ? '?variant=' + v.id : '')) history.replaceState(null, '', u); }
      }
      gs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b || !g[b.dataset.v]) return; grind = b.dataset.v; segOn(gs, grind); buildSizes(); sync(); });
      ss.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; oz = +b.dataset.v; segOn(ss, oz); sync(); });
      fs.addEventListener('click', function (e) { var b = e.target.closest('button'); if (!b) return; e.preventDefault(); segOn(fs, b.dataset.v); sec.querySelector('input[value="sub"]').checked = true; sync(); });
      $$('input[name="aw-pt"]', sec).forEach(function (r) { r.addEventListener('change', sync); });
      sec.querySelector('[data-aw-qm]').addEventListener('click', function () { q.value = Math.max(1, (+q.value || 1) - 1); });
      sec.querySelector('[data-aw-qp]').addEventListener('click', function () { q.value = (+q.value || 1) + 1; });
      function add(btn) {
        var v = sec._v; if (!v) return; var it = { id: v.id, quantity: Math.max(1, +q.value || 1) };
        if (ptype() === 'sub') { var pl = (g[grind].plans || {})[segVal(fs)]; if (pl) it.selling_plan = +pl; }
        addItems([it], btn, err);
      }
      sec.querySelector('[data-aw-padd]').addEventListener('click', function (e) { add(e.currentTarget); });
      var b2 = sec.querySelector('[data-aw-padd2]'); if (b2) b2.addEventListener('click', function (e) { add(e.currentTarget); });
      buildSizes(); sync();

      // Fecha estimada de despacho (3 a 5 días hábiles)
      var eta = sec.querySelector('[data-aw-eta]');
      if (eta) {
        var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; } return d; };
        var f = function (d) { return d.toLocaleDateString(document.documentElement.lang || 'en', { weekday: 'short', day: 'numeric', month: 'short' }); };
        var now = new Date();
        eta.innerHTML = '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg><span>' + L('eta').replace('{a}', f(addBiz(now, 3))).replace('{b}', f(addBiz(now, 5))) + '</span>';
      }

      // Galería
      var slides = $$('.aw-slide', sec), th = sec.querySelector('[data-aw-thumbs]'), gi = 0;
      function show(i) { gi = (i + slides.length) % slides.length; slides.forEach(function (s, k) { s.classList.toggle('on', k === gi); }); $$('button', th).forEach(function (b, k) { b.classList.toggle('on', k === gi); }); }
      slides.forEach(function (s, k) { var im = s.querySelector('img'); if (!im) return; var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', L('view_image') + ' ' + (k + 1)); b.innerHTML = '<img src="' + (im.currentSrc || im.src) + '" alt="" loading="lazy">'; b.addEventListener('click', function () { show(k); }); th.appendChild(b); });
      var gp = sec.querySelector('[data-aw-gprev]'), gn = sec.querySelector('[data-aw-gnext]');
      if (slides.length < 2) { gp.style.display = gn.style.display = 'none'; th.style.display = 'none'; }
      gp.addEventListener('click', function () { show(gi - 1); }); gn.addEventListener('click', function () { show(gi + 1); });
      var sx = null, main = sec.querySelector('.aw-gal-main');
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(gi + (dx < 0 ? 1 : -1)); sx = null; });
      show(0);

      // Barra fija móvil
      var sticky = sec.querySelector('[data-aw-sticky]'), mainBtn = sec.querySelector('[data-aw-padd]');
      if (sticky && mainBtn) addEventListener('scroll', function () { var r = mainBtn.getBoundingClientRect(); sticky.classList.toggle('show', r.bottom < 0); }, { passive: true });
    });
  }

  /* ---------- Pie de página en acordeón (móvil) ---------- */
  function initFooter() { $$('footer.aw-foot .cols h5').forEach(function (h) { h.addEventListener('click', function () { h.parentElement.classList.toggle('open'); }); }); }

  function init(root) { initReveal(root); initReels(root); initShop(root); initSub(root); initPDP(root); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-aw-pickfreq]'); if (!a) return;
    var box = $('[data-aw-sub]'); if (!box) return;
    var seg = box.querySelector('[data-aw-sf]'); var b = seg && seg.querySelector('[data-v="' + a.dataset.awPickfreq + '"]');
    if (b) b.click();
  });
  document.addEventListener('DOMContentLoaded', function () { initHeader(); initParallax(); initFooter(); initCartBar(); init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
